import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../common/util/input/Link'
import { formatWAX } from '../helpers/FormatLinks'

export const AuctionDetails = ({ auctionDetails }) => {
    const { t } = useTranslation('common')
    return (
        <div className={'mt-8 lg:mt-0'}>
            {t('asset.bids')}
            <Table size="small">
                <TableBody>
                    {auctionDetails.bids &&
                        auctionDetails.bids.map((bid) => (
                            <TableRow
                                className={cn({
                                    'bg-primaryt text-sm font-bold md:font-semibold':
                                        bid.bid === auctionDetails.topBid,
                                })}
                            >
                                <TableCell>
                                    <Link href={`/user/${bid.bidder}`}>
                                        {bid.bidder}
                                    </Link>
                                </TableCell>
                                <TableCell>{formatWAX(bid.bid)}</TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </div>
    )
}
